module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet-20fb4824030f7baae768b4ee5cf7122c.jpg";